// src/firebase1.ts (Oyun 1)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyC4oGNwKuWm67DnyDIt5FSediSpqE8OpwA",
    authDomain: "paradox-f3aa6.firebaseapp.com",
    projectId: "paradox-f3aa6",
    storageBucket: "paradox-f3aa6.firebasestorage.app",
    messagingSenderId: "842869732441",
    appId: "1:842869732441:web:7b5ec8c200c90ea7b2ad48",
};

const app = initializeApp(firebaseConfig, "paradox"); // Her oyun için benzersiz bir isim
export const db5 = getFirestore(app);